export const PHONE_NUMBER_REGEX = /^\+\d+$|^\d+$/
export const EXTRACT_MISSION_REGEX = /<div[^>]*class="wp-block-group__inner-container"[^>]*>[\s\S]*?<\/div>/g
export const EXTRACT_MISSION_LINK_REGEX = /<a[^>]*class="wp-block-button__link[^>]*>[\s\S]*?<\/a>/g
export const EXTRACT_PARAGRAPHS_REGEX = /<p[^>]*>[\s\S]*?<\/p>/g
export const EXTRACT_HEADING_REGEX = /<h2[^>]*>[\s\S]*?<\/h2>/g
